import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemText, Button } from '@mui/material';
import { format } from 'date-fns';
import { useAuth } from '@contexts/AuthContext';
import { receptionService } from '@services/receptionService';
import type { Appointment } from '@app-types/reception';

export default function ReceptionCheckIn() {
  const { user } = useAuth();
  const clinicId = user?.clinicId || '';
  const [arrived, setArrived] = useState<Appointment[]>([]);
  const [loading, setLoading] = useState(true);
  const today = format(new Date(), 'yyyy-MM-dd');

  useEffect(() => {
    if (!clinicId) return;
    receptionService.getAppointments({ date: today, status: ['arrived'], page: 1, pageSize: 100 })
      .then((r) => { setArrived(r.items); })
      .catch(() => setArrived([]))
      .finally(() => setLoading(false));
  }, [clinicId, today]);

  const handleStartConsultation = async (id: string) => {
    try {
      await receptionService.setStatus(id, 'in_consultation');
      setArrived((prev) => prev.filter((a) => a.id !== id));
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Sala de așteptare</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Pacienți sosiți (check-in făcut) – {today}
      </Typography>
      {loading ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>Se încarcă...</Paper>
      ) : arrived.length === 0 ? (
        <Paper sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">Niciun pacient în sală de așteptare</Typography>
        </Paper>
      ) : (
        <Paper>
          <List>
            {arrived.map((a) => (
              <ListItem key={a.id} divider>
                <ListItemText
                  primary={`${a.animal?.name || '-'} – ${a.owner?.firstName || ''} ${a.owner?.lastName || ''}`}
                  secondary={a.scheduledAt ? format(new Date(a.scheduledAt), 'HH:mm') : ''}
                />
                <Button size="small" variant="contained" onClick={() => handleStartConsultation(a.id)}>
                  Începe consultația
                </Button>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
    </Box>
  );
}
